export default "__VITE_ASSET__5856c434__"